@if (data) {
<div class="preview-content" [class.mobile-view]="viewMode === 'mobile'"
  [style.background-color]="viewMode === 'mobile' ? '#e5e5e5' : data.backgroundColor" [style.display]="'flex'"
  [style.flex-direction]="viewMode === 'mobile' ? 'row' : 'column'" [style.justify-content]="
    viewMode === 'mobile'
      ? ''
      : (data.currentPageQuestions.length || 0) > 0
      ? 'flex-start'
      : 'center'
  " [style.align-items]="
    viewMode === 'mobile'
      ? ''
      : (data.currentPageQuestions.length || 0) > 0
      ? data.horizontalAlignment
      : 'center'
  ">
  <div class="preview-body-content" [class.mobile-view]="viewMode === 'mobile'" [style.display]="'flex'"
    [style.flex-direction]="'column'" [style.background-color]="
      viewMode === 'mobile' ? data.backgroundColor : 'transparent'
    ">
    @if (data.isEmpty && !data.showUserInfoPage) {
    <div class="empty-state" [class.mobile-view]="viewMode === 'mobile'" [style.color]="data.descriptionColor">
      <div class="empty-state__icon" aria-hidden="true">
        <i class="fa-solid fa-circle-question"></i>
      </div>
      <h2 class="empty-state__title" [style.color]="data.titleColor" [style.font-family]="data.titleFontFamily"
        [style.font-weight]="data.titleFontWeight">No questions yet</h2>
      <p class="empty-state__description" [style.color]="data.descriptionColor"
        [style.font-family]="data.descriptionFontFamily" [style.font-size]="data.descriptionFontSize">
        Add questions to your questionnaire to see how they look with your theme. Go to the Builder tab to create and
        arrange questions.
      </p>
      <app-button [label]="'Add Question'" (click)="onAddQuestion()" [variant]="'primary'" [size]="'medium'"
        [width]="'160'" [style.background-color]="data.buttonBgColor" [style.color]="data.buttonColor"
        [style.font-family]="data.buttonFontFamily" [style.font-weight]="data.buttonFontWeight"></app-button>
    </div>
    } @else {
    @if (data.showUserInfoPage && data.currentPage === 0) {
    <div class="questions-section" [style.gap]="data.questionSpacing + 'px'"
      [class.mobile-view]="viewMode === 'mobile'">
      @if ((data.userInfoFields.length) > 0) {
      @for (field of data.userInfoFields; track field.fieldName) {
      <div class="question-item">
        <h3 class="question-title" [class.mobile-view]="viewMode === 'mobile'" [style.color]="data.titleColor"
          [style.font-size]="data.titleFontSize" [style.font-family]="data.titleFontFamily"
          [style.font-weight]="data.titleFontWeight">
          {{ field.fieldName | titlecase }}
          @if (field.mandatoryFlag) {
          <span class="required-asterisk">*</span>
          }
        </h3>
        <div class="row-width">
          @switch (field.fieldType) {
          @case ('EMAIL') {
          <app-input-text [type]="'email'" [placeholder]="'Enter ' + (field.fieldName  || '' | titlecase)"
            [size]="'small'" (click)="$event.stopPropagation()"></app-input-text>
          }
          @case ('NUMBER') {
          <app-number [placeholder]="'Enter ' + (field.fieldName || '' | titlecase)" [size]="'small'"
            (click)="$event.stopPropagation()"></app-number>
          }
          @case ('DATE') {
          <app-date-picker [placeholder]="'Enter ' + (field.fieldName || '' | titlecase)" [size]="'small'"
            (click)="$event.stopPropagation()"></app-date-picker>
          }
          @case ('PHONE') {
          <app-mobile-number [placeholder]="'Enter ' + (field.fieldName || '' | titlecase)" [size]="'small'"
            (click)="$event.stopPropagation()"></app-mobile-number>
          }
          @case ('TEXT') {
          <app-input-text [type]="'text'" [placeholder]="'Enter ' + (field.fieldName || '' | titlecase)"
            [size]="'small'" (click)="$event.stopPropagation()"></app-input-text>
          }
          @case ('WEBSITE_URL') {
          <app-input-text [type]="'url'" [placeholder]="'Enter ' + (field.fieldName || '' | titlecase)" [size]="'small'"
            (click)="$event.stopPropagation()"></app-input-text>
          }
          @default {
          <app-input-text [type]="'text'" [placeholder]="'Enter ' + (field.fieldName || '' | titlecase)"
            [size]="'small'" (click)="$event.stopPropagation()"></app-input-text>
          }
          }
        </div>
        <!-- <input [type]="getUserInfoInputType(field.fieldType)" class="question-input user-info-input"
          [placeholder]="'Enter ' + (field.fieldName || '')"
          /> -->
      </div>
      }

      } @else {
      <p class="m-0 p-0" [style.color]="data.descriptionColor" [style.font-family]="data.descriptionFontFamily">
        No user info fields configured
      </p>
      }
    </div>
    <div class="user-info-next-wrap">
      @if (data.canSkipUserInfo && data.userInfoStatusCondition === 'OPTIONAL') {
      <button type="button" class="user-info-skip-btn" [class.mobile-view]="viewMode === 'mobile'"
        (click)="onSkipUserInfo()" [style.border-color]="data.buttonBgColor" [style.color]="data.buttonBgColor"
        [style.font-family]="data.buttonFontFamily" [style.font-weight]="data.buttonFontWeight">
        Skip
      </button>
      }

      <button type="button" class="user-info-next-btn user-info-next-btn--next"
        [class.mobile-view]="viewMode === 'mobile'" (click)="onNext()" [style.background-color]="data.buttonBgColor"
        [style.color]="data.buttonColor" [style.font-family]="data.buttonFontFamily"
        [style.font-weight]="data.buttonFontWeight">
        Next
        <i class="fa-solid fa-chevron-right text-xs"></i>
      </button>
    </div>
    }
    @if (data.currentPage > 0) {
    @if (data.currentPageQuestions.length === 0) {
    <div class="empty-state questions-list-empty" [class.mobile-view]="viewMode === 'mobile'"
      [style.color]="data.descriptionColor">
      <div class="empty-state__icon" aria-hidden="true">
        <i class="fa-solid fa-circle-question"></i>
      </div>
      <h2 class="empty-state__title" [style.color]="data.titleColor" [style.font-family]="data.titleFontFamily"
        [style.font-weight]="data.titleFontWeight">No questions yet</h2>
      <p class="empty-state__description" [style.color]="data.descriptionColor"
        [style.font-family]="data.descriptionFontFamily" [style.font-size]="data.descriptionFontSize">
        Add questions to your questionnaire to see how they look with your theme. Go to the Builder tab to create and
        arrange questions.
      </p>
      <app-button [label]="'Add Question'" (click)="onAddQuestion()" [variant]="'primary'" [size]="'medium'"
        [width]="'160'" [style.background-color]="data.buttonBgColor" [style.color]="data.buttonColor"
        [style.font-family]="data.buttonFontFamily" [style.font-weight]="data.buttonFontWeight"></app-button>
    </div>
    } @else {
    <div class="questions-section" [style.gap]="data.questionSpacing + 'px'"
      [class.mobile-view]="viewMode === 'mobile'">
      @for (question of data.currentPageQuestions; track question.questionId) {
      <div class="question-item">
        <h3 class="question-title" [class.mobile-view]="viewMode === 'mobile'" [style.color]="data.titleColor"
          [style.font-size]="data.titleFontSize" [style.font-family]="data.titleFontFamily"
          [style.font-weight]="data.titleFontWeight">
          <!-- {{ question.order }}.  -->
          @if (question.required) {
          <span class="required-asterisk">*</span>
          }
          {{ question.question }}
        </h3>
        <div class="question-item-body">
          @switch (question.questionType) {
          @case (questionType.CHOICE_BASED) {
          <app-choice-based [question]="question" [data]="data" [page]="'theme'"></app-choice-based>
          }
          @case (questionType.TEXT_INPUT) {
          <app-text-input [question]="question"></app-text-input>
          }
          @case (questionType.SLIDERS) {
          <app-sliders [question]="question"></app-sliders>
          }
          @case (questionType.RATING_SCALE) {
          <app-rating-scale [question]="question"
            [viewMode]="viewMode === 'mobile' ? 'mobile' : 'desktop'"></app-rating-scale>
          }
          @case (questionType.NPS) {
          <app-nps [question]="question" [viewMode]="viewMode === 'mobile' ? 'mobile' : 'desktop'" [data]="data"
            [page]="'theme'"></app-nps>
          }
          @case (questionType.RANK_ORDER) {
          <app-rank-order [question]="question"
            [viewMode]="viewMode === 'mobile' ? 'mobile' : 'desktop'"></app-rank-order>
          }
          @case (questionType.SOCIAL_REVIEW) {
          <app-social-review [question]="question"></app-social-review>
          }
          @default {
          <div class="preview-unsupported-type" [style.color]="data.descriptionColor">
            Unsupported question type
          </div>
          }
          }
        </div>
      </div>
      }
    </div>
    @if (data.displayTotalPages > 0) {
    <div class="pagination-controls">
      @if (data.canGoPrevious) {
      <button type="button" class="pagination-btn pagination-btn--prev" (click)="onPrevious()"
        [class.mobile-view]="viewMode === 'mobile'" [style.background-color]="data.buttonBgColor"
        [style.color]="data.buttonColor" [style.font-family]="data.buttonFontFamily"
        [style.font-weight]="data.buttonFontWeight">
        <i class="fa-solid fa-chevron-left text-xs"></i>
        Previous
      </button>
      }
      <button type="button" class="pagination-btn pagination-btn--next" [disabled]="!data.canGoNext" (click)="onNext()"
        [class.mobile-view]="viewMode === 'mobile'" [style.background-color]="data.buttonBgColor"
        [style.color]="data.buttonColor" [style.font-family]="data.buttonFontFamily"
        [style.font-weight]="data.buttonFontWeight">
        Next
        <i class="fa-solid fa-chevron-right text-xs"></i>
      </button>
    </div>
    }
    }
    }
    }
  </div>
</div>
}